import app from './app';

export default function reportError(error: Error | object) {
	app('errorHandler').report(error);
}
